import React, { useLayoutEffect, useState, useEffect } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";

import Modal from "react-modal";
import Swal from "sweetalert2";
import { TextBox, CheckBox, SelectBox, TagBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { groupService } from "../../../apis/apiServices/Group";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faEye,
  faRefresh,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@iconify/react";

export default function AssetGroupComponent(props) {
  // Permissions from props.featurePermission
  const canAdd = !!props?.featurePermission?.canAdd;
  const canEdit = !!props?.featurePermission?.canEdit;
  const canDelete = !!props?.featurePermission?.canDelete;

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Group";
    getGroupList();
  }, []);

  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [AssetGroupList, setAssetGroupList] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [state, setState] = useState([]);

  const closeViewModal = () => {
    setIsModalOpen(false);
  };

  const [Group, SetGroup] = useState({
    id: 0,
    code: "",
    name: "",
    ledgerCode: "",
    isActive: true,
    deptId: 0,
    departmentIdList: [],
  });

  const getGroupList = async () => {
    try {
      const response = await groupService.getGroupList();
      setAssetGroupList(response?.data);
    } catch (error) {
      console.log("Error getCityList===>", error);
    }
  };

  const getDepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setDepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getGroupList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitted(true);

    const newErrors = {};
    if (!Group.name) newErrors.name = "Please enter group type name";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitted(false);
      return;
    }

    try {
      let body = {
        id: Group.id,
        code: Group?.code || "",
        name: Group?.name || "",
        ledgerCode: Group?.ledgerCode || "",
        isActive: Group?.isActive || false,
        ModifiedBy: 0,
        departmentId: Group?.deptId || 0,
        departmentIdList: Group?.departmentIdList,
      };

      const response = await groupService.addGroup(body);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setIsSubmitted(false);
        setErrors({});
        return;
      }

      getGroupList();
      setIsSubmitted(false);
      setErrors({});

      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        navigate("/AssetGroup", { replace: true });
        closeModal();
      });
    } catch (error) {
      console.log(error);
    }
  };

  const openModal = () => {
    setIsGroupModalOpen(true);
  };

  const closeModal = () => {
    setIsGroupModalOpen(false);
    setIsSubmitted(false);
    setErrors({});
    SetGroup({
      id: 0,
      code: "",
      name: "",
      ledgerCode: "",
      isActive: true,
      deptId: 0,
      departmentIdList: [],
    });
  };

  const handleInputChange = (e, field) => {
    SetGroup((prev) => ({
      ...prev,
      [field]: e.value,
    }));
  };

  const renderStatusCell = ({ value }) => {
    const isActive = value === true;

    return (
      <div>
        <span />
        {isActive ? "Active" : "Inactive"}
      </div>
    );
  };
  const handleRowClick = (e) => {
    SetGroup({
      id: e.data.id,
      code: e.data.code,
      name: e.data.name,
      ledgerCode: e.data.ledgerCode,
      isActive: e.data.isActive,
      deptId: e.data.departmentId,
      departmentIdList: e.data.departmentIdList,
      departmentNameList: e.data.departmentNameList,
    });
  };
  const handledelete = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Deleted", "", "success");
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={AssetGroupList}
              // columnAutoWidth={true}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              onRowClick={(e) => handleRowClick(e)}
              allowColumnResizing={false}
              allowColumnReordering={true}
              width={"100%"}
              onToolbarPreparing={(e) => {
                // build toolbar items conditionally
                const items = [];

                if (canAdd) {
                  items.push({
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "plus",
                      text: "Add",
                      hint: "Add",
                      type: "default",
                      stylingMode: "contained",
                      onClick: () => openModal(),
                    },
                  });
                }

                items.push({
                  location: "before",
                  widget: "dxButton",
                  options: {
                    icon: "refresh",
                    text: "Refresh",
                    hint: "Refresh",
                    type: "default",
                    stylingMode: "outlined",
                    onClick: () => getGroupList(),
                  },
                });

                items.push({
                  location: "after",
                  widget: "dxButton",
                  options: {
                    icon: "upload",
                    text: "Upload Asset Group",
                    hint: "Upload Asset Group",
                    type: "default",
                    stylingMode: "outlined",
                    onClick: () => {
                      try {
                        navigate("/UploadAssetGroup");
                      } catch (error) {
                        console.log(error);
                      }
                    },
                  },
                });

                e.toolbarOptions.items.unshift(...items);
              }}
            >
              <HeaderFilter visible={false} />

              <Column
                width="60px"
                caption={""}
                cellRender={(cellData) => {
                  return (
                    <span>
                      {/* View icon - keep always visible or gate as needed */}
                      {/* {canView && (
                        <Icon
                          className="iconify-size mr-2"
                          title="View"
                          tooltip="View"
                          icon="solar:document-text-outline"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsModalOpen(true)}
                        />
                      )} */}

                      {canEdit && (
                        <Icon
                          className="iconify-size mr-2"
                          title="Edit"
                          tooltip="Edit"
                          icon="solar:pen-line-duotone"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsGroupModalOpen(true)}
                        />
                      )}

                      {canDelete && (
                        <Icon
                          className="iconify-size"
                          title="Delete"
                          tooltip="Delete"
                          icon="fluent:delete-32-regular"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => handledelete(e)}
                        />
                      )}
                    </span>
                  );
                }}
              ></Column>

              <Column
                width="100px"
                dataField="code"
                caption="Code"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                width="400px"
                dataField="name"
                caption="Name"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                width="400px"
                dataField="ledgerCode"
                caption="GLedger Code"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                width="400px"
                dataField="departmentNameList"
                caption="Department"
                allowFiltering={false}
                allowSearch={true}
                cellRender={(cellData) => {
                  return <>{cellData?.data?.departmentNameList?.join(", ")}</>;
                }}
              />
              <Column
                width="100px"
                dataField="isActive"
                caption="Status"
                cellRender={renderStatusCell}
                alignment="left"
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />

              <Export enabled={false} fileName="Vendors" />
            </DataGrid>
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={isGroupModalOpen}
        className="react-modal custom-modal-small"
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Asset Group Modal"
        onAfterOpen={async () => {
          await getDepartmentDropdown();
        }}
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">Add/Edit Asset Group</div>
          </div>

          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="form-group">
                  <label>
                    Name <span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className={`form-control ${
                      errors.name ? "is-invalid" : ""
                    }`}
                    placeholder="Enter asset group name"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Group.name}
                    onValueChanged={(e) => handleInputChange(e, "name")}
                  />
                  {errors.name && (
                    <div className="error invalid-feedback">{errors.name}</div>
                  )}
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="form-group">
                  <label>
                    Select Department <span className="text-danger">*</span>
                  </label>

                  <TagBox
                    dataSource={departmentDropdown}
                    value={Group.departmentIdList || []}
                    displayExpr="departmentName"
                    valueExpr="id"
                    placeholder="Select departments"
                    searchEnabled={true}
                    showSelectionControls={true}
                    applyValueMode="useButtons"
                    multiline={true}
                    onValueChanged={(e) => {
                      SetGroup((prev) => ({
                        ...prev,
                        departmentIdList: e.value ?? [],
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>Code </label>
                  <TextBox
                    className={`form-control ${
                      errors.code ? "is-invalid" : ""
                    }`}
                    placeholder="Enter code"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Group.code}
                    onValueChanged={(e) => handleInputChange(e, "code")}
                  />
                  {errors.code && (
                    <div className="error invalid-feedback">{errors.code}</div>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    GL Code <span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className={`form-control ${
                      errors.ledgerCode ? "is-invalid" : ""
                    }`}
                    placeholder="Enter GL Code"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Group.ledgerCode}
                    onValueChanged={(e) => handleInputChange(e, "ledgerCode")}
                  />
                  {errors.ledgerCode && (
                    <div className="error invalid-feedback">
                      {errors.ledgerCode}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div>
                  <CheckBox
                    text="Is Active"
                    value={Group.isActive}
                    onValueChanged={(e) => handleInputChange(e, "isActive")}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Cancel
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              {isSubmitted ? (
                <span title="In process">
                  <i className="fas fa-spinner fa-spin"></i> In process
                </span>
              ) : (
                <span title="Submit">
                  <i className="fas fa-check"></i> Submit
                </span>
              )}
            </button>
          </div>
        </form>
      </Modal>
      <Modal
        ariaHideApp={false}
        isOpen={isModalOpen}
        className="react-modal resmodel"
        onRequestClose={closeViewModal}
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">View Asset Group</div>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Code: </span> {Group.code}
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Name: </span> {Group.name}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <p>
                    <span className="labelview">Status: </span>{" "}
                    {Group.isActive ? "Active" : "Inactive"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeViewModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Close{" "}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
